import User from './user.vue'

export default User



// WEBPACK FOOTER //
// ./src/views/user/user/index.js